import React from 'react';

interface Props {
  src: string
  alt?: string
  style?: React.CSSProperties
}

const Img = ({ src, alt, style }: Props) => (
  <img src={src} alt={alt} style={style} />

);

export default Img;
